import styled from "styled-components";

export const StyledCheckSerialNumber = styled.div`
${({theme}) => `
  .check-sn-title{
    /* Include heading 5 from mixin.scss*/
    @media (min-width: 960px) {
        font-size: ${theme.uptimeFontSizes.desktop.fz7}px;
        line-height: ${theme.uptimeSpace[11]}px;
    }      
    /* Include end*/

    margin: ${theme.uptimeSpace[8]}px ${theme.uptimeSpace[0]}px;
    &:after{
      content: '*';
      color: ${theme.uptimeColors.generalColors.state.danger.light};
      padding-left: ${theme.uptimeSpace[3]}px;
    }
  }
  .section-sn {
    box-shadow: ${theme.uptimeSpace[2]}px ${theme.uptimeSpace[5]}px ${theme.uptimeSpace[15]}px ${theme.uptimeSpace[2]}px rgb(36 14 47 / 6%);
    border-radius: ${theme.uptimeSpace[6]}px;
    padding: ${theme.uptimeSpace[6]}px;
    .label-form {
      font-weight: bold;
    }
    .required.label-form::after{
      content: '*';
      color: ${theme.uptimeColors.generalColors.state.danger.light};
      padding-left: ${theme.uptimeSpace[3]}px;
    }
    .sn-control {
      display: grid;
      position: relative;
      margin-top: ${theme.uptimeSpace[5]}px;
      gap: ${theme.uptimeSpace[5]}px;
      grid-template-columns: 100%;
      
      @media (min-width: 450px) {
        grid-template-columns: 70% 20%;
      }
      @media (min-width: ${theme.breakpoints.sm}) {
        grid-template-columns: 85% 20%;
      }
    } 
  }
  .section-sn.section-sn-check-user{
    box-shadow : none;
    padding : ${theme.uptimeSpace[0]};
    margin: 0px;

    @media (min-width: ${theme.breakpoints.sm}) {
      margin: ${theme.uptimeSpace[5]}px 100px;
    }
    .label-form {
      font-size: ${theme.uptimeFontSizes.desktop.fz5}px;
      line-height: ${theme.uptimeLineHeights.desktop.lh2}px;
    }
    .sn-control{
      margin-top: ${theme.uptimeSpace[4]}px;
    }
  }
  .section-sn-error{
    font-size: ${theme.uptimeFontSizes.desktop.fz4}px !important;
    color: ${theme.uptimeColors.generalColors.state.danger.light};
    margin: 0;
    @media (min-width: ${theme.breakpoints.sm}) {
      margin: ${theme.uptimeSpace[5]}px 100px;
    }
    .sn-control {
      display: grid;
      position: relative;
      margin-top: ${theme.uptimeSpace[5]}px;
      grid-template-columns: 1% 99%; 
      gap: ${theme.uptimeSpace[10]}px;
      align-items: center;

      @media (min-width: ${theme.breakpoints.md}) {
        gap: ${theme.uptimeSpace[5]}px;
      }
    }
    .MuiSvgIcon-root{
      font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
    }
    p {
      line-height: 1;
    }
  }
`}`;
export const StyledDeviceDetailForm = styled.div`
  ${({theme}) => `
  .SN-device-details {   
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;  
    margin: ${theme.uptimeSpace[0]}px auto;
    box-sizing: border-box;
    .text-input{
      padding: ${theme.uptimeSpace[5]}px 0;
    }
    .device-details-title {
        padding: ${theme.uptimeSpace[5]}px ${theme.uptimeSpace[0]}px;                
        .uptime-typography{
            font-family:  ${theme.fonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
            font-weight: bold;
            font-size: ${theme.uptimeFontSizes.desktop.fz6}px;
        }
    }
    .divider {
        padding: ${theme.uptimeSpace[20]}px ${theme.uptimeSpace[0]}px ${theme.uptimeSpace[6]}px;
    }
    .text-show{
      text-align: center;
      line-height: ${theme.uptimeLineHeights.desktop.lh5}px;
      p{
        margin-top: ${theme.uptimeSpace[10]}px;
      }
    }

    @media (min-width: ${theme.breakpoints.lg}) {
      .text-input {
        padding: ${theme.uptimeSpace[5]}px;
      }
    }
  }
`}`